import { Navigate, Outlet, useOutletContext } from 'react-router-dom'
import useLimitedMode from '../../services/subscription/useLimitedMode'

interface Props {
  /** Where to send someone who cannot open this form. */
  fallbackPath: string
}

/**
 * Keeps the create and edit forms shut while the account is unactivated, so a
 * bookmarked or pasted URL cannot open a form whose save is guaranteed to
 * 403. The buttons that lead here are disabled for the same reason; this is
 * the half that a URL cannot walk around.
 */
const LimitedModeRoute = ({ fallbackPath }: Props) => {
  const { isLimited, isLoading } = useLimitedMode()
  // The list pages hand their rows down through the outlet, and the edit forms
  // read them; forward it so slotting this guard in between changes nothing.
  const context = useOutletContext()

  // Deciding before the subscription resolves would either flash the form open
  // or bounce someone who is perfectly entitled to it.
  if (isLoading) return null

  if (isLimited) return <Navigate to={fallbackPath} replace />

  return <Outlet context={context} />
}

export default LimitedModeRoute
